import { TimesheetEntryType } from '..';
const getAllocationsGroupMeta = (entry)=>({
        projectId: entry.project.id,
        projectName: entry.project.name,
        isInvalid: entry.isInvalid,
        companyLogoUrl: entry.companyLogoUrlOfProject
    });
const getWorkCustomOption = (entry)=>{
    if (entry.type === TimesheetEntryType.TaskEntry) {
        return {
            value: entry.task.id,
            label: entry.task.name,
            type: entry.type,
            extra: entry.task
        };
    }
    if (entry.type === TimesheetEntryType.PhaseEntry) {
        return {
            value: entry.projectPhase.id,
            label: entry.projectPhase.name,
            type: entry.type,
            extra: entry.projectPhase
        };
    }
    return undefined;
};
const getCustomOptionCategory = (category)=>{
    if (category) {
        return {
            value: category.categoryId,
            label: category.categoryName
        };
    }
    return undefined;
};
const getCustomOptionRole = (role, team)=>{
    if (team) {
        return {
            value: `${role.roleId}_${team.teamId}`,
            // Placeholder (team) name is the primary label, role is secondary.
            label: team.teamName,
            description: role.roleName,
            extra: {
                type: 'TEAM'
            }
        };
    }
    return {
        value: `${role.roleId}`,
        label: role.roleName,
        extra: {
            type: 'ROLE'
        }
    };
};
const setFieldValuesToFormattedFieldValues = (fields)=>{
    return fields === null || fields === void 0 ? void 0 : fields.map((field)=>{
        var _field_formattedFieldValue;
        return {
            ...field,
            fieldValue: (_field_formattedFieldValue = field.formattedFieldValue) !== null && _field_formattedFieldValue !== void 0 ? _field_formattedFieldValue : field.fieldValue
        };
    });
};
const getAllocationSourceId = (entry)=>{
    if (entry.type === TimesheetEntryType.TaskEntry) {
        return entry.task.id;
    }
    if (entry.type === TimesheetEntryType.PhaseEntry) {
        return entry.projectPhase.id;
    }
    return entry.project.id;
};
export const transformer = {
    toAllocationEntryGroupsWithMeta: (res, canOverrideDateLock, isWeekFreezedAfter)=>{
        const result = [];
        let timeEntryId = 1;
        res.forEach((entry)=>{
            var _setFieldValuesToFormattedFieldValues;
            const meta = getAllocationsGroupMeta(entry);
            const allocationEntry = {
                work: getWorkCustomOption(entry),
                project: entry.project,
                timeEntryId,
                isInvalid: entry.isInvalid,
                billable: entry.billable,
                category: getCustomOptionCategory(entry.category),
                fields: (_setFieldValuesToFormattedFieldValues = setFieldValuesToFormattedFieldValues(entry.fields)) !== null && _setFieldValuesToFormattedFieldValues !== void 0 ? _setFieldValuesToFormattedFieldValues : [],
                role: (()=>{
                    const roleOption = getCustomOptionRole(entry.role, entry.team);
                    return roleOption;
                })(),
                date: entry.date,
                duration: entry.minutes,
                type: entry.type,
                marked: !!entry.marked,
                allocationId: entry.allocationId,
                allocationSourceId: getAllocationSourceId(entry),
                projectFinancialsBudgetId: entry.projectFinancialsBudgetId
            };
            const projectGroup = result.find(([allocationMeta])=>allocationMeta.projectId === meta.projectId);
            if (projectGroup) {
                projectGroup[1].push(allocationEntry);
            } else {
                result.push([
                    meta,
                    [
                        allocationEntry
                    ]
                ]);
            }
            timeEntryId += 1;
        });
        const sortedResult = result.sort((a, b)=>{
            return Number(a[0].isInvalid) - Number(b[0].isInvalid);
        });
        sortedResult.forEach(([, entries])=>{
            entries.sort((a, b)=>{
                const dateAMs = new Date(a.date).getTime();
                const dateBMs = new Date(b.date).getTime();
                const isALocked = isWeekFreezedAfter && !canOverrideDateLock ? new Date(a.date).getTime() <= new Date(isWeekFreezedAfter).getTime() : false;
                const isBLocked = isWeekFreezedAfter && !canOverrideDateLock ? new Date(b.date).getTime() <= new Date(isWeekFreezedAfter).getTime() : false;
                const aMarkedOrLocked = a.marked || isALocked;
                const bMarkedOrLocked = b.marked || isBLocked;
                if (aMarkedOrLocked === bMarkedOrLocked) {
                    return dateAMs - dateBMs;
                }
                return Number(aMarkedOrLocked) - Number(bMarkedOrLocked);
            });
        });
        return sortedResult;
    }
};
